<div class="site-background-main"></div>
<div id="main-wrapper" style="position: relative;">
    <div class="d-flex mobile-all-position" style="gap:28px;padding-bottom: 24px;">
        <div class="header">
            <app-heder-game class="position-header left"/>
        </div>
        <div class="left-field-right show-mobile">
            <button class="mobile-toggle-btn" (click)="toggleLeftMenu()" title="Меню гравця">
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#757575"><path d="M197-96q-15 0-28-12.5T156-136v-102q0-86.45 53.5-152.72Q263-457 348-475q-38 28-59 68.91-21 40.92-21 88.09l-1 182q0 11 3.5 21t9.5 19h-83Zm141 0q-17 0-28.5-11.5T298-136v-181.96q0-67.04 47.53-114.54Q393.07-480 460.29-480h181.49q67.22 0 114.72 47.5T804-318.43v60.86q0 66.57-47.25 114.07T642-96H338Zm142-465q-63.49 0-107.75-43.95-44.25-43.94-44.25-107 0-63.05 44.25-107.55Q416.51-864 480-864t107.75 44.5Q632-775 632-711.95q0 63.06-44.25 107Q543.49-561 480-561Z"/></svg>
                <span>{{ 'game.txtProfile' | translate }}</span>
            </button>
            <app-mobile-field/>
        </div>
        <div class="lcontain" [ngClass]="{'open': isLeftMenuOpen(), 'closing': false}" style="flex: 0 0 auto;">
            <div class="header-profile">
                <span>{{ 'game.txtProfile' | translate }}</span>
            </div>
            <div class="sidebar border-right col-md-12 col-lg-12 p-0">
                <div class="all-player-info d-flex flex-column">
                    <div class="player-info d-flex justify-content-center align-items-center">
                        <div class="player-icon d-flex justify-content-center align-items-center">
                            <img src="/assets/{{ players.player.gender_icon }}.png" alt="{{ players.player.name }}"/>
                        </div>
                        <div class="d-flex flex-column gap-8">
                            <span class="player-name">{{ players.player.name }}</span>
                            <div class="player-line"></div>
                            <div class="player-quest-info d-flex justify-content-between align-items-center">
                                <div class="quest-info d-flex flex-column align-items-start">
                                    <div class="quest-info-icons d-flex align-items-center justify-content-start" [innerHTML]="getQuestIcons(players.player.rq_id)"></div>
                                    @if(gameInfo.gameInfo?.type === 'quest'){
                                        <div class="quest-info-name">{{ getStringQuest(players.player.rq_id) }}</div>
                                    }
                                    @if(gameInfo.gameInfo?.type === 'role'){
                                        <div class="quest-info-name">{{ getStringRole( players.player.rq_id ) }}</div>
                                    }
                                </div>
                                <div class="other-info d-flex align-items-center justify-content-center" (click)="getFieldInfo(players.player.rq_id)">
                                    <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.2667 8L6.26671 12L5.33337 11.0667L8.40004 8L5.33337 4.93333L6.26671 4L10.2667 8Z" fill="#D9D9D9"/>
                                    </svg> -->
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.2667 8L6.26671 12L5.33337 11.0667L8.40004 8L5.33337 4.93333L6.26671 4L10.2667 8Z" fill="black" fill-opacity="0.5"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="player-progress-all d-flex flex-column">
                        <div class="block-player-result d-flex justify-content-between align-items-center">
                            <span><app-progress-player [levelCard]="1000" [readNow]="true" [points]="points" [maxPoints]="maxPoints"></app-progress-player></span>
                            <span>{{ points }}/{{ maxPoints }} XP</span>
                        </div>
                        <div class="block-progress">
                            <mat-progress-bar class="progress-rounded" mode="determinate" [value]="successRate"></mat-progress-bar>
                        </div>
                    </div>
                </div>
                <!-- // TODO показати коли хоть щось в  difficultyLevels є -->
                @if(allStatus.activeLevel.length > 0){ 
                <div class="difficulty-player d-flex flex-column" [attr.data-length]="'length-'+allStatus.activeLevel.length">
                    <div class="difficulty-player__block d-flex flex-column" [class]="hide() ? 'collapsed' : 'expanded'">
                        @if(allStatus.activeLevel.includes(7)){
                            <div class="difficulty-player__level d-flex flex-column">
                                <div class="difficulty-player__info d-flex justify-content-between align-items-center">
                                    <span><app-progress-player [levelCard]="7" [readNow]="true" [points]="difficulty.difficultyLevels()['seventh'].points" [maxPoints]="difficulty.difficultyLevels()['seventh'].maxPoints"></app-progress-player></span>
                                    @if(currentLevel('seventh')){
                                        <span>{{ 'game.txtCurrentLevel' | translate }}: 7</span>
                                    }@else{
                                        <span style="text-transform: capitalize;">{{ 'game.txtRatingLevel' | translate }} 7</span>
                                    }
                                </div>
                                <div class="difficulty-player__progress">
                                    <mat-progress-bar mode="determinate" value="{{calcLevelPrecent(difficulty.difficultyLevels()['seventh'].points, difficulty.difficultyLevels()['seventh'].maxPoints)}}"></mat-progress-bar>
                                </div>
                            </div>
                        }
                        @if(allStatus.activeLevel.includes(6)){
                            <div class="difficulty-player__level d-flex flex-column">
                                <div class="difficulty-player__info d-flex justify-content-between align-items-center">
                                    <span><app-progress-player [levelCard]="6" [readNow]="true" [points]="difficulty.difficultyLevels()['sixth'].points" [maxPoints]="difficulty.difficultyLevels()['sixth'].maxPoints"></app-progress-player></span>
                                    @if(currentLevel('sixth')){
                                        <span>{{ 'game.txtCurrentLevel' | translate }}: 6</span>
                                    }@else{
                                        <span style="text-transform: capitalize;">{{ 'game.txtRatingLevel' | translate }} 6</span>
                                    }
                                </div>
                                <div class="difficulty-player__progress">
                                    <mat-progress-bar mode="determinate" value="{{calcLevelPrecent(difficulty.difficultyLevels()['sixth'].points, difficulty.difficultyLevels()['sixth'].maxPoints)}}"></mat-progress-bar>
                                </div>
                            </div>
                        }
                        @if(allStatus.activeLevel.includes(5)){
                            <div class="difficulty-player__level d-flex flex-column">
                                <div class="difficulty-player__info d-flex justify-content-between align-items-center">
                                    <span><app-progress-player [levelCard]="5" [readNow]="true" [points]="difficulty.difficultyLevels()['fifth'].points" [maxPoints]="difficulty.difficultyLevels()['fifth'].maxPoints"></app-progress-player></span>
                                    @if(currentLevel('fifth')){
                                        <span>{{ 'game.txtCurrentLevel' | translate }}: 5</span>
                                    }@else{
                                        <span style="text-transform: capitalize;">{{ 'game.txtRatingLevel' | translate }} 5</span>
                                    }
                                </div>
                                <div class="difficulty-player__progress">
                                    <mat-progress-bar mode="determinate" value="{{calcLevelPrecent(difficulty.difficultyLevels()['fifth'].points, difficulty.difficultyLevels()['fifth'].maxPoints)}}"></mat-progress-bar>
                                </div>
                            </div>
                        }
                        @if(allStatus.activeLevel.includes(4)){
                            <div class="difficulty-player__level d-flex flex-column">
                                <div class="difficulty-player__info d-flex justify-content-between align-items-center">
                                    <span><app-progress-player [levelCard]="4" [readNow]="true" [points]="difficulty.difficultyLevels()['fourth'].points" [maxPoints]="difficulty.difficultyLevels()['fourth'].maxPoints"></app-progress-player></span>
                                    @if(currentLevel('fourth')){
                                        <span>{{ 'game.txtCurrentLevel' | translate }}: 4</span>
                                    }@else{
                                        <span style="text-transform: capitalize;">{{ 'game.txtRatingLevel' | translate }} 4</span>
                                    }
                                </div>
                                <div class="difficulty-player__progress">
                                    <mat-progress-bar mode="determinate" value="{{calcLevelPrecent(difficulty.difficultyLevels()['fourth'].points, difficulty.difficultyLevels()['fourth'].maxPoints)}}"></mat-progress-bar>
                                </div>
                            </div>
                        }
                        @if(allStatus.activeLevel.includes(3)){
                            <div class="difficulty-player__level d-flex flex-column">
                                <div class="difficulty-player__info d-flex justify-content-between align-items-center">
                                    <span><app-progress-player [levelCard]="3" [readNow]="true" [points]="difficulty.difficultyLevels()['third']?.points || 0" [maxPoints]="difficulty.difficultyLevels()['third']?.maxPoints || 10"></app-progress-player></span>
                                    @if(currentLevel('third')){
                                        <span>{{ 'game.txtCurrentLevel' | translate }}: 3</span>
                                    }@else{
                                        <span style="text-transform: capitalize;">{{ 'game.txtRatingLevel' | translate }} 3</span>
                                    }
                                </div>
                                <div class="difficulty-player__progress">
                                    <mat-progress-bar mode="determinate" value="{{calcLevelPrecent(difficulty.difficultyLevels()['third'].points, difficulty.difficultyLevels()['third'].maxPoints)}}"></mat-progress-bar>
                                </div>
                            </div>
                        }
                        @if(allStatus.activeLevel.includes(2)){
                            <div class="difficulty-player__level d-flex flex-column">
                                <div class="difficulty-player__info d-flex justify-content-between align-items-center">
                                    <span><app-progress-player [levelCard]="2" [readNow]="true" [points]="difficulty.difficultyLevels()['second']?.points || 0" [maxPoints]="difficulty.difficultyLevels()['second']?.maxPoints || 10"></app-progress-player></span>
                                    @if(currentLevel('second')){
                                        <span>{{ 'game.txtCurrentLevel' | translate }}: 2</span>
                                    }@else{
                                        <span style="text-transform: capitalize;">{{ 'game.txtRatingLevel' | translate }} 2</span>
                                    }
                                </div>
                                <div class="difficulty-player__progress">
                                    <mat-progress-bar mode="determinate" value="{{calcLevelPrecent(difficulty.difficultyLevels()['second'].points, difficulty.difficultyLevels()['second'].maxPoints)}}"></mat-progress-bar>
                                </div>
                            </div>
                        }
                        @if(allStatus.activeLevel.includes(1)){
                            <div class="difficulty-player__level d-flex flex-column">
                                <div class="difficulty-player__info d-flex justify-content-between align-items-center">
                                    <span><app-progress-player [levelCard]="1" [readNow]="true" [points]="difficulty.difficultyLevels()['first']?.points || 0" [maxPoints]="difficulty.difficultyLevels()['first']?.maxPoints || 10"></app-progress-player></span>
                                    @if(currentLevel('first')){
                                        <span>{{ 'game.txtCurrentLevel' | translate }}: 1</span>
                                    }@else{
                                        <span style="text-transform: capitalize;">{{ 'game.txtRatingLevel' | translate }} 1</span>
                                    }
                                </div>
                                <div class="difficulty-player__progress">
                                    <mat-progress-bar mode="determinate" value="{{calcLevelPrecent(difficulty.difficultyLevels()['first'].points, difficulty.difficultyLevels()['first'].maxPoints)}}"></mat-progress-bar>
                                </div>
                            </div>
                        }
                    </div>
                    <!-- // TODO  коли більше одного difficultyLevels -->
                    @if(countLevel() > 1){ 
                    <div class="difficulty-player__hide-show d-flex justify-content-center align-items-center">
                        <div class="d-flex justify-content-center align-items-center difficulty-player__button-icon" [class]="hide() ? '' : 'rotate'" (click)="blockState($event)">
                            <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 10.2667L4 6.26671L4.93333 5.33337L8 8.40004L11.0667 5.33337L12 6.26671L8 10.2667Z" fill="#D9D9D9"/>
                            </svg> -->
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 10.2667L4 6.26671L4.93333 5.33337L8 8.40004L11.0667 5.33337L12 6.26671L8 10.2667Z" fill="black" fill-opacity="0.5"/>
                            </svg>
                        </div>
                    </div>
                    }
                </div>
                }
                <!-- <div class="block-player-info py-2 px-1 d-flex justify-content-start align-items-center gap-2">
                    <div class="icon-user d-flex justify-content-center align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M185-80q-17 0-29.5-12.5T143-122v-105q0-90 56-159t144-88q-40 28-62 70.5T259-312v190q0 11 3 22t10 20h-87Zm147 0q-17 0-29.5-12.5T290-122v-190q0-70 49.5-119T459-480h189q70 0 119 49t49 119v64q0 70-49 119T648-80H332Zm148-484q-66 0-112-46t-46-112q0-66 46-112t112-46q66 0 112 46t46 112q0 66-46 112t-112 46Z"/></svg>
                    </div>
                    <div class="user-profession d-flex justify-content-start align-items-center gap-1 text-white">
                        <span class="material-symbols-outlined">
                            {{ players.player.gender_icon }}
                        </span>
                        <div class="name">{{ players.player.name }}</div>
                    </div>
                </div> -->
                <!-- <div class="success-game mt-3 py-2 px-1 text-white">
                    @if(gameInfo.gameInfo?.type === 'quest'){
                        <div class="title">{{ 'game.txtGTypeQ' | translate }}</div>
                        <hr/>
                        <div class="description">{{ getStringQuest(players.player.rq_id) }}</div>
                    }
                    @if(gameInfo.gameInfo?.type === 'role'){
                        <div class="title">Ваша роль в игре</div>
                        <hr />
                        <div class="description">{{ getStringRole( players.player.rq_id ) }}</div>
                    }
                </div> -->
                
                <!-- <div class="success-game mt-3 py-2 px-1 text-white">
                    <div class="title">{{ 'game.txtGameProgress' | translate }}</div>
                    <hr/>
                    <div class="d-flex justify-content-between align-items-center gap-2">
                        
                        <div class="description"><span>{{ 'game.txtGameRatingAll' | translate }}: </span>{{ points }} / {{ maxPoints }} ({{successRate}}%)</div>
                        @if(!configuration.configuration?.config?.is_demo){
                            <app-progress-player [levelCard]="1000"></app-progress-player>
                        }
                    </div>
                    @if(difficulty.difficultyLevels()['first'].maxPoints !== 0){
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="description"><span>{{ 'game.txtRatingLevel' | translate }} 1: </span>{{ difficulty.difficultyLevels()['first'].points }} / {{ difficulty.difficultyLevels()['first'].maxPoints }} ({{calcLevelPrecent(difficulty.difficultyLevels()['first'].points, difficulty.difficultyLevels()['first'].maxPoints)}} %)</div>
                            @if(!configuration.configuration?.config?.is_demo){
                                <app-progress-player [levelCard]="1"></app-progress-player>
                            }
                        </div>
                    }
                    @if(difficulty.difficultyLevels()['second'].maxPoints !== 0){
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="description"><span>{{ 'game.txtRatingLevel' | translate }} 2: </span>{{ difficulty.difficultyLevels()['second'].points }} / {{ difficulty.difficultyLevels()['second'].maxPoints }} ({{calcLevelPrecent(difficulty.difficultyLevels()['second'].points, difficulty.difficultyLevels()['second'].maxPoints)}} %)</div>
                            @if(!configuration.configuration?.config?.is_demo){
                                <app-progress-player [levelCard]="2"></app-progress-player>
                            }
                        </div>                    
                    }
                    @if(difficulty.difficultyLevels()['third'].maxPoints !== 0){
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="description"><span>{{ 'game.txtRatingLevel' | translate }} 3: </span>{{ difficulty.difficultyLevels()['third'].points }} / {{ difficulty.difficultyLevels()['third'].maxPoints }} ({{calcLevelPrecent(difficulty.difficultyLevels()['third'].points, difficulty.difficultyLevels()['third'].maxPoints)}} %)</div>
                            @if(!configuration.configuration?.config?.is_demo){
                                <app-progress-player [levelCard]="3"></app-progress-player>
                            }
                        </div>
                    }
                    @if(difficulty.difficultyLevels()['fourth'].maxPoints !== 0){
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="description"><span>{{ 'game.txtRatingLevel' | translate }} 4: </span>{{ difficulty.difficultyLevels()['fourth'].points }} / {{ difficulty.difficultyLevels()['fourth'].maxPoints }} ({{calcLevelPrecent(difficulty.difficultyLevels()['fourth'].points, difficulty.difficultyLevels()['fourth'].maxPoints)}} %)</div>
                            @if(!configuration.configuration?.config?.is_demo){
                                <app-progress-player [levelCard]="4"></app-progress-player>
                            }
                        </div>
                    }
                    @if(difficulty.difficultyLevels()['fifth'].maxPoints !== 0){
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="description"><span>{{ 'game.txtRatingLevel' | translate }} 5: </span>{{ difficulty.difficultyLevels()['fifth'].points }} / {{ difficulty.difficultyLevels()['fifth'].maxPoints }} ({{calcLevelPrecent(difficulty.difficultyLevels()['fifth'].points, difficulty.difficultyLevels()['fifth'].maxPoints)}} %)</div>
                            @if(!configuration.configuration?.config?.is_demo){
                                <app-progress-player [levelCard]="5"></app-progress-player>
                            }
                        </div>
                    }
                    @if(difficulty.difficultyLevels()['sixth'].maxPoints !== 0){
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="description"><span>{{ 'game.txtRatingLevel' | translate }} 6: </span>{{ difficulty.difficultyLevels()['sixth'].points }} / {{ difficulty.difficultyLevels()['sixth'].maxPoints }} ({{calcLevelPrecent(difficulty.difficultyLevels()['sixth'].points, difficulty.difficultyLevels()['sixth'].maxPoints)}} %)</div>
                            @if(!configuration.configuration?.config?.is_demo){
                                <app-progress-player [levelCard]="6"></app-progress-player>
                            }
                        </div>
                    }
                    @if(difficulty.difficultyLevels()['seventh'].maxPoints !== 0){
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="description"><span>{{ 'game.txtRatingLevel' | translate }} 7: </span>{{ difficulty.difficultyLevels()['seventh'].points }} / {{ difficulty.difficultyLevels()['seventh'].maxPoints }} ({{calcLevelPrecent(difficulty.difficultyLevels()['seventh'].points, difficulty.difficultyLevels()['seventh'].maxPoints)}} %)</div>
                            @if(!configuration.configuration?.config?.is_demo){
                                <app-progress-player [levelCard]="7"></app-progress-player>
                            }
                        </div>
                    }
                </div> -->
                @if(teamMaxPoints > 0){
                    <div class="success-game my-3 py-2 px-1 text-white">
                        <div class="title d-flex justify-content-between">
                            <span>{{ 'game.txtTeamsRating' | translate }}:</span>
                            <span>{{teamMaxPoints}}</span>
                        </div>
                        <hr/>
                        <div class="description d-flex justify-content-between">
                            <span>{{ 'game.txtTeamPoints' | translate }}:</span>
                            <span>{{ teamPoints }} ({{myFnRounding((teamPoints/teamMaxPoints)*100)}}%)</span>
                        </div>
                    </div>
                }

                <!-- <div class="success-game my-3 py-2 px-1 text-white">
                    <div class="title">{{ 'game.txtAdditionalInfo' | translate }}</div>
                    <hr/>
                    <div class="description">{{ 'game.txtSomeTimeTxt' | translate }}</div>
                </div> -->
                <app-target></app-target>
                @if(allStatus.isPractices()){
                    <section class="sector-practices">
                        <app-health-practices [points]="points" [maxPoints]="maxPoints"/>
                    </section>
                }
                
                <section>
                    <app-achievement></app-achievement>
                </section>
            </div>
            <!-- Кнопка закриття для мобільних -->
            <button class="sidebar-close-btn" (click)="closeLeftMenu()" title="Закрити">
                <span>{{ 'buttons.txtClose' | translate }}</span>
            </button>
        </div>
        <div class="content-body left">
            <main class="col-md-12 ms-sm-auto col-lg-12 d-flex flex-column gap-2">
                <!-- @if(configuration.configuration.config.player_management){
                    @if(players.player.is_starter && players.players.length > 1){
                    <div class="d-flex justify-content-end align-items-center gap-2">
                        <app-user-management [players]="players.players" [uuid]="uuid" [turning]="gameInfo.gameInfo.turning_player_id"></app-user-management>
                    </div>
                    }
                }
                
                <div class="d-flex justify-content-between align-items-center gap-2" style="overflow: auto;">
                    <app-players class="d-flex justify-content-start align-items-center gap-2" [turning]="gameInfo.gameInfo.turning_player_id" [type]="gameInfo.gameInfo.type" [players]="players.players"></app-players>

                </div> -->

                <!-- <h3>{{ 'game.txtTitlePlayindField' | translate }}</h3>
                @if(gameInfo.gameInfo.type === 'role'){                
                    <div class="play-field type-one">
                        <app-play-field-circle></app-play-field-circle>
                    </div>
                }@else{
                   
                     <div class="play-field type-one">
                        <app-play-field-circle></app-play-field-circle>
                    </div>
                    <div class="play-field">
                        <app-play-field-line></app-play-field-line>
                    </div>
                } -->
                <div>
                    <app-dice [turning]="gameInfo.gameInfo.turning_player_id" [player]="players.player" [typeGame]="gameInfo.gameInfo.type" gameMode="single"></app-dice>
                </div>
                <div>
                    <app-card-info [player]="players.player" [turning]="gameInfo.gameInfo.turning_player_id" [playersLeng]="players.players.length" [players]="players.players" [userResponse]="response"></app-card-info>
                    <app-pass-ball  [turning]="gameInfo.gameInfo.turning_player_id" [player]="players.player"></app-pass-ball>
                </div>
            </main>
        </div>
    </div>

    <!-- Кнопки управління для мобільних (видимі тільки на екранах < 1000px) -->
    
</div>
<div style="padding: 10px 0;"></div>
<app-footer/>
